import {
    getAccount,
    listAccounts
} from './queries';
import {
    createAccount,
    updateAccount,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {
    Account,
    CreateAccount,
    DeleteAccount,
    GetAccount,
    ListAccounts,
    UpdateAccount
} from "../types.ts";
import {
    notifyError,
    notifySuccess
} from "../../../../components/PlatformNotification";
import {generateClient} from "aws-amplify/api";
import {deleteAccount} from "./mutations.ts";
import {
    showErrorNotifications,
    showSuccessNotification
} from "../../../../components/ServiceNotifications.tsx";

// import {
//     notifyError,
//     notifySuccess
// } from "@flexinet/ui-components";


const client = generateClient();

const normalizeFilter = (filter: { [key: string]: string }) => {
    return Object.keys(filter)
                 .reduce((acc: { [key: string]: object }, key: string) => {
                     if (filter[key] !== '') {
                         acc[key] = {eq: filter[key]};
                     }
                     return acc;
                 }, {});

};

export const fetchRecords = async (filter?: { [key: string]: string }) => {

    // filter looks like this - {organizationId: 'xxxxx', email: 'XXXXXXXXXXXXX'}

    let transformedFilter = {};
    if (typeof filter !== 'undefined') {
        transformedFilter = normalizeFilter(filter);
    }

    // after normalization filter looks like this - {organizationId: {eq: 'xxxxx'}, email: {eq: 'XXXXXXXXXXXXX'}}

    try {
        const response = await client.graphql<GraphQLQuery<ListAccounts>>({
                                                                              query: listAccounts,
                                                                              variables: {filter: transformedFilter},
                                                                          });
        return response.data?.listAccounts;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const fetch = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<GetAccount>>({
                                                                            query: getAccount,
                                                                            variables: {id: id},
                                                                        });
        return response.data?.getAccount;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const add = async (payload: object) => {

    try {
        const response = await client.graphql<GraphQLQuery<CreateAccount>>({
                                                                               query: createAccount,
                                                                               variables: {input: payload},
                                                                           });
        notifySuccess();
        return response.data?.createAccount;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const update = async (id: string, record: Account) => {


    console.debug('IN UPDATE', id, record);

    // FNP-776: WHITELIST the mutation input to exactly the UpdateAccountInput fields —
    // never blacklist-and-spread. The fetched Account carries read-only fields
    // (sub, email, username, customerId, created, deletionRequested*, user, …) that
    // UpdateAccountInput rejects; sending the whole record broke Save + the
    // Set-up-billing flow with "field not defined for input object type
    // 'UpdateAccountInput'". Same class as FNP-774/760/764.
    const input: {
        id: string;
        accountType?: Account['accountType'];
        accountStatus?: Account['accountStatus'];
    } = { id: record.id ?? id };
    if (record.accountType != null) {
        input.accountType = record.accountType;
    }
    if (record.accountStatus != null) {
        input.accountStatus = record.accountStatus;
    }

    try {
        const response = await client.graphql<GraphQLQuery<UpdateAccount>>({
                                                                               query: (updateAccount),
                                                                               variables: {input},
                                                                           });

        notifySuccess('Account updated');
        return response.data?.updateAccount;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};


// FNP-117: calls the FNP-285 deleteAccount mutation. Backend flips the row
// to PENDING_DELETION + emits `account-removal-requested` for the
// workflows-api playbook. Returns the soft-deleted Account.
export const deleteRecord = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<DeleteAccount>>({
                                                                                query: (deleteAccount),
                                                                                variables: {input: {id}},
                                                                            });
        console.debug('delete account response', response);
        showSuccessNotification();
        return response.data?.deleteAccount;
    } catch (e) {
        showErrorNotifications(e)
    }
};

// FNP-717: updateAccountCustomerId was REMOVED. It called the generic updateAccount
// mutation with customerId in the input, but FNP-490 removed customerId from
// UpdateAccountInput (it is single-writer, set only by the IAM/admin-only
// setAccountCustomerId). The call was rejected by the schema, so the portal's
// "set up billing profile" step always failed and left account.customerId null.
// The account->customer link now happens entirely server-side via billing-api's
// provisionBillingCustomerForCurrentAccount — the browser no longer writes it.
